<template>
  <ValidationProvider rules="required" name="template" slim vid="template">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel> Template </BaseFormLabel>
        <div>
          <BaseFormSelect v-model="computedValue" :options="options" :disabled="loading" />
        </div>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    productType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    options() {
      return this.$store.getters['ui/accProductTemplates/items'].map((accProductTemplate) => ({
        value: accProductTemplate.id,
        label: accProductTemplate.name,
      }));
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.fetchAccProductTemplates();
  },
  methods: {
    async fetchAccProductTemplates() {
      try {
        this.loading = true;

        await this.$store.dispatch('ui/accProductTemplates/load', {
          query: {
            filter: {
              product_type: this.productType,
            },
          },
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
